export default __webpack_public_path__ + "static/hero_home_img_6-9d4be8b273fc0b86b332e6bb3aef64cc.png";